import { render } from "./TapStacksPrivacyPolicy.vue?vue&type=template&id=2ccdb978&scoped=true"
const script = {}

import "./TapStacksPrivacyPolicy.vue?vue&type=style&index=0&id=2ccdb978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccdb978"]])

export default __exports__